import { useEffect, useRef, useState } from "react";

function About() {
  const intervalRef = useRef(null);
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  const slides = [
    {
      title: "OUR MISSION",
      content:
        "To gather and equip worshippers for their calling. Keeping them spiritually fit for the mission, with their hope anchored in the living God, as they draw nations to His heart through the ministry of worship."
    },
    {
      title: "RELENTLESS PURSUIT",
      content:
        "We create environments where worshippers are empowered, encouraged, and equipped through fellowship and the Word of God. Building strong community among worshippers. Aligning character through biblical teaching. Cultivating excellence in worship and skill."
    },
    {
      title: "BETTER WORSHIPPER, HEALED",
      content:
        "We are committed to the wholeness of every worshipper; spirit, soul, and body. Encouraging healing and growth through testimonies. Establishing a culture of accountability and support."
    },
    {
      title: "OUR HEART",
      content:
        "Worship is more than a song, it is a lifestyle. Our heart is to see worshippers healed, aligned, and released to impact nations through Spirit-led worship."
    }
  ];

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setVisible(false);

      setTimeout(() => {
        setIndex((prev) => (prev + 1) % slides.length);
        setVisible(true);
      }, 900);
    }, 6000);

    return () => clearInterval(intervalRef.current);
  }, []);

  const handleDotClick = (i) => {
    setVisible(false);

    setTimeout(() => {
      setIndex(i);
      setVisible(true);
    }, 700);
  };

  return (
    <section
      style={{
        padding: "100px 20px",
        background: "#f9f9f9",
        display: "flex",
        justifyContent: "center"
      }}
    >
      <div
        style={{
          width: "75%",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }}
      >
        {/* TITLE */}
        <h2 style={{ fontSize: "32px", marginBottom: "40px" }}>
          ABOUT US
        </h2>

        {/* FIXED FRAME */}
        <div
          style={{
            width: "100%",
            maxWidth: "900px",

            // 🔥 FIXED HEIGHT (increased to prevent clipping)
            height: "360px",

            position: "relative",
            overflow: "hidden",

            // 🔥 breathing space so text doesn’t touch edges
            padding: "20px 0"
          }}
        >
          {slides.map((slide, i) => (
            <div
              key={i}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",

                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",

                opacity: index === i && visible ? 1 : 0,
                transform:
                  index === i && visible
                    ? "translateY(0px)"
                    : "translateY(10px)",

                transition: "opacity 2s ease-in-out, transform 2s ease-in-out"
              }}
            >
              <h3 style={{ fontSize: "24px", marginBottom: "15px" }}>
                {slide.title}
              </h3>

              <p
                style={{
                  fontSize: "16px",
                  lineHeight: "1.9",
                  color: "#333",
                  maxWidth: "800px"
                }}
              >
                {slide.content}
              </p>
            </div>
          ))}
        </div>

        {/* DOTS */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "25px",
            gap: "10px"
          }}
        >
          {slides.map((_, i) => (
            <div
              key={i}
              onClick={() => handleDotClick(i)}
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                background: index === i ? "#000" : "#ccc",
                cursor: "pointer"
              }}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default About;